import React, { useState } from "react";
import "./SignUp.css"; // Import the CSS file
// import "../../../src/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { IoMdCloseCircle } from "react-icons/io";
import { GiCombinationLock } from "react-icons/gi";
import {
  FaMobileAlt,
  FaCaretDown,
  FaUser,
  FaEye,
  FaEyeSlash,
  FaWhatsapp,
} from "react-icons/fa"; // Import icons
import axios from "axios";
import apiBaseUrl from "../../config/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const SignUp = (props) => {
  const navigate = useNavigate();
  const { signup } = useAuth();

  const [formData, setFormData] = useState({
    site_code: apiBaseUrl.sitecodes,
    user_name: "",
    password: "",
    user_type: "User",
    master_id: apiBaseUrl.childAdmin, // Default to child admin
    refercode: "",
    otp: "",
  });

  // console.log("apiBaseUrl", apiBaseUrl);

  const [showPopup, setShowPopup] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State to toggle password visibility
  const [otpBtn, setOtpBtn] = useState(false); // State to toggle password visibility
  const [showOtpVerification, setShowOtpVerification] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log("formData", formData);
    // return false;
    if (confirmPassword !== formData.password) {
      toast.error("Password Not Matched!", { autoClose: 2000 });
      return false;
    }
    if (!formData?.otp) {
      toast.error("Otp Not Matched!", { autoClose: 2000 });
      return false;
    }

    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}users/addUsers`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(formData),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success("Registered successful!", { autoClose: 2000 });

          // localStorage.setItem(
          //   "userdata",
          //   JSON.stringify(response.data.resultData)
          // );
          console.log("response.data.resultData", response.data.resultData);
          signup(response.data.resultData[0]);

          // setTimeout(() => {
          //   props?.toggleSignUpPopup(false);
          //   props?.handleClose();
          // }, 1000);
          if (props?.togglePopup) {
            props.togglePopup("Yes");
          }
          if (props?.handleClose) {
            props.handleClose();
          }
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during registering", {
          autoClose: 2000,
        });
      });
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle between showing and hiding password
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword); // Toggle between showing and hiding password
  };

  async function getOtp() {
    const mobileNumber = String(formData.user_name).trim();

    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Please enter a valid 10 digit mobile number", {
        autoClose: 2000,
      });
      return;
    }

    setOtpBtn(true);
    var config = {
      method: "post",
      url: `${apiBaseUrl.apiUrl}otps/sendOtp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify({
        user_name: mobileNumber,
        site_code: apiBaseUrl.sitecodes,
      }),
    };
    axios(config)
      .then(function (response) {
        if (response.data.result) {
          toast.success("OTP Send successful!", { autoClose: 2000 });
          setShowOtpVerification(true);
        } else {
          toast.error(response.data.resultMessage, { autoClose: 2000 });
        }
        setOtpBtn(false);
      })
      .catch(function (error) {
        console.log(error);
        toast.error("An error occurred during sending OTP", {
          autoClose: 2000,
        });
        setOtpBtn(false);
      });
  }

  return (
    <>
      {/* Login Button */}
      {/* <button type="button" className="btn btn-warning" onClick={togglePopup}>Sign Up</button> */}
      {/* <button className="pushable-signup submit-btn login-trigger " onClick={togglePopup}>
        <span className="front-signup">Sign Up</span> 
      </button> */}

      {/* Popup */}
      <main className="signup-page">
        <section className="signup-page-card">
          <span className="close-btn">
            <IoMdCloseCircle onClick={props?.toggleSignUpPopup} />
          </span>
          <div className="login-popup-logo">
            <img className="form-logo" src="../Images/logo.png" alt="" />
          </div>
          <form className="signup-page-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="display_username"
              className="signup-page-input"
              placeholder="Username 4 To 15 Alphanumeric"
              autoComplete="username"
            />
            <div className="signup-mobile-row">
              <span className="signup-country-code">
                <span aria-hidden="true">🇮🇳</span>
                +91
                <FaCaretDown aria-hidden="true" />
              </span>

              <input
                type="tel"
                name="user_name"
                value={formData.user_name}
                onChange={handleInputChange}
                placeholder="Mobile No"
                className="signup-page-input signup-mobile-input"
                autoComplete="tel"
                required
              />
            </div>
            {showOtpVerification && (
              <div className="signup-otp">
                <input
                  type="number"
                  name="otp"
                  value={formData.otp}
                  onChange={(e) => handleInputChange(e)}
                  placeholder="Enter OTP"
                  className="otp-input"
                  style={{ borderRadius: "8px", height: "43px" }}
                />
              </div>
            )}
            <div className="signup-password-row">
              <input
                className="signup-page-input"
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password 6 To 20 Alphanumeric"
                required
                value={formData.password}
                onChange={handleInputChange}
              />
            </div>
            <p className="signup-password-note">
              (Must be contained alphanumeric and more than 6 letters)
            </p>
            {showOtpVerification && (
              <div
                className="signup-password"
                style={{ borderRadius: "8px", height: "43px" }}
              >
                <GiCombinationLock
                  size={20}
                  color="#e9b02e"
                  style={{ marginRight: 0, marginLeft: 5 }}
                />
                <input
                  className="password-input"
                  type={showConfirmPassword ? "text" : "password"} // Toggle between 'text' and 'password'
                  name="confirmpass"
                  placeholder="Confirm Password"
                  required
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={{ marginTop: "0px" }}
                />
                <span
                  className="confirm-password-toggle-signup mr-1"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPassword ? (
                    <FaEyeSlash size={20} />
                  ) : (
                    <FaEye size={20} />
                  )}
                </span>{" "}
                {/* Eye icon to toggle password visibility */}
              </div>
            )}
            <input
              type="text"
              name="refercode"
              placeholder="Referral Code (Optional)"
              value={formData.refercode}
              onChange={handleInputChange}
              className="signup-page-input signup-referral-input"
            />
            <div className="signup-page-actions">
              <p className="signup-otp-info">
                By continuing you will receive a one-time verification code to
                your phone number by SMS.
              </p>

              <button
                type="button"
                className="signup-get-otp-button"
                disabled={otpBtn}
                onClick={getOtp}
              >
                {otpBtn ? "SENDING OTP..." : "GET OTP ON WHATSAPP"}
              </button>

              <span className="signup-or-divider">OR</span>

              <p className="signup-ready-id-text">
                Get Your Ready-Made ID From Whatsapp
              </p>

              <button type="button" className="signup-whatsapp-button">
                <FaWhatsapp aria-hidden="true" />
                <span>WHATSAPP NOW</span>
              </button>

              {showOtpVerification && (
                <button type="submit" className="signup-register-button">
                  REGISTER
                </button>
              )}

              <p className="signup-login-link">
                Already have account?
                <button type="button" onClick={() => navigate("/dashboard")}>
                  Log In
                </button>
              </p>
            </div>
            {/* Added onClick event */}

            <div className="signup-bonus-row">
              <div className="signup-bonus-card">
                <strong>300% BONUS</strong>
                <span>1ST DEPOSIT</span>
              </div>

              <div className="signup-bonus-card">
                <strong>50% BONUS</strong>
                <span>2ND DEPOSIT</span>
              </div>

              <div className="signup-bonus-card">
                <strong>10% BONUS</strong>
                <span>EVERY DEPOSIT</span>
              </div>
            </div>
          </form>
        </section>
      </main>
    </>
  );
};

export default SignUp;
